import angular from 'angular'
import { PayrollSelectComponent } from './payroll-select.component';

export const PayrollSharedModule = angular
    .module("apex.mainApp.payroll.shared", [])
    .component("apexPayrollSelect", PayrollSelectComponent)
    .name
